import script from "./VergleichHeaderMobil.vue?vue&type=script&setup=true&lang=js"
export * from "./VergleichHeaderMobil.vue?vue&type=script&setup=true&lang=js"

import "./VergleichHeaderMobil.vue?vue&type=style&index=0&id=a498c8b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a498c8b8"]])

export default __exports__